import React, { Component, Fragment } from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { withRouter } from 'react-router';
import moment from 'moment';
import _ from 'lodash';
import { isNullOrUndefined } from 'util';

import { DatePickerField, InputField } from 'Common/SemanticWrapper';
import { TitledCard } from 'Components/';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import {
  VERIFICATION_RESULTS_LETTERS_FORM_NAME,
  InputMode,
} from 'Common/FormEnum';
import { VerificationResultsLettersFieldEnum as Fields } from 'Common/FieldEnum';
import { YesNoOptions, normalizePhone } from 'Common/FormHelper';
import { UseStudentAddressButtonGroup } from 'Common/Components/UseStudentAddressButtonGroup/UseStudentAddressButtonGroup';

class ResultsLettersFormContainer extends Component {
  printTypeOptions = [
    { value: 0, label: 'Unprinted' },
    { value: 1, label: 'Printed' },
  ];

  renderResultsCounts = () => {
    let counts = { Unprinted: '', Printed: '', NoResults: '' };
    if (this.props.resultsCounts) {
      const obj = this.props.resultsCounts;
      counts.Printed = obj.PrintedValue ? obj.PrintedValue : 0;
      counts.Unprinted = obj.UnprintedValue ? obj.UnprintedValue : 0;
      counts.NoResults = obj.NoResultsValue ? obj.NoResultsValue : 0;
    }
    return (
      <Grid.Row columns={3} style={{ background: '#E2E2E2' }}>
        <Grid.Column>{counts.Unprinted}</Grid.Column>
        <Grid.Column>{counts.Printed}</Grid.Column>
        <Grid.Column>{counts.NoResults}</Grid.Column>
      </Grid.Row>
    );
  };

  render() {
    return (
      <Fragment>
        <Form name={VERIFICATION_RESULTS_LETTERS_FORM_NAME}>
          <TitledCard title={'Letter Settings'}>
            <Grid>
              <Grid.Row>
                <Grid.Column width={4}>
                  <Field
                    label={'Date of Letter:'}
                    name={Fields.LetterDate}
                    component={DatePickerField}
                    type="text"
                    openToDate={moment()}
                  />
                </Grid.Column>
                <Grid.Column width={5}>
                  <Field
                    label={'Date hearing must be requested by:'}
                    name={Fields.HearingDate}
                    component={DatePickerField}
                    type="text"
                    openToDate={moment()}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Field
                    style={{ width: '80%' }}
                    label={
                      'Child Nutrition Staff Person to be contacted for more information:'
                    }
                    name={Fields.StaffPersonName}
                    component={InputField}
                    type="text"
                    maxLength={75}
                  />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column width={6}>
                  <Field
                    style={{ width: '100%' }}
                    label={'Child Nutrition Staff Person Phone #:'}
                    name={Fields.StaffPersonPhone}
                    component={InputField}
                    type="text"
                    maxLength={14}
                    mode={InputMode.Integer}
                    normalize={normalizePhone}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </TitledCard>
          <TitledCard title={'Print Options'}>
            <Grid>
              <Grid.Row>
                <Grid.Column width={4}>
                  <ReduxFormButtonGroup
                    label={'Show Site Name'}
                    options={YesNoOptions}
                    formName={VERIFICATION_RESULTS_LETTERS_FORM_NAME}
                    fieldName={Fields.ShowSiteName}
                  />
                </Grid.Column>
                <Grid.Column width={4}>
                  <UseStudentAddressButtonGroup
                    label={'Use Student Address If Available'}
                    formName={VERIFICATION_RESULTS_LETTERS_FORM_NAME}
                    fieldName={Fields.UseStudentAddress}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={4}>
                  <ReduxFormButtonGroup
                    label={'Print which letters?'}
                    options={this.printTypeOptions}
                    formName={VERIFICATION_RESULTS_LETTERS_FORM_NAME}
                    value={this.props.formValues[Fields.PrintType]}
                    fieldName={Fields.PrintType}
                  />
                </Grid.Column>
                <Grid.Column width={5}>
                  <Grid
                    className={'segment'}
                    style={{
                      fontWeight: 'bold',
                      marginTop: '26px',
                      minWidth: '300px',
                    }}
                  >
                    <Grid.Row
                      columns={3}
                      divided={true}
                      style={{
                        borderBottom: '1px solid #C0C0C0',
                      }}
                    >
                      <Grid.Column>Unprinted</Grid.Column>
                      <Grid.Column>Printed</Grid.Column>
                      <Grid.Column>No Results</Grid.Column>
                    </Grid.Row>
                    {this.renderResultsCounts()}
                  </Grid>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </TitledCard>
        </Form>
      </Fragment>
    );
  }
}

const validate = values => {
  var errors = [];

  if (isNullOrUndefined(values[Fields.LetterDate])) {
    errors[Fields.LetterDate] = 'Letter date is required.';
  }
  if (isNullOrUndefined(values[Fields.HearingDate])) {
    errors[Fields.HearingDate] = 'Hearing date is required.';
  }
  if (isNullOrUndefined(values[Fields.StaffPersonName])) {
    errors[Fields.StaffPersonName] = 'Staff person name is required.';
  }
  if (isNullOrUndefined(values[Fields.StaffPersonPhone])) {
    errors[Fields.StaffPersonPhone] = 'Staff person phone is required.';
  } else {
    if (
      values[Fields.StaffPersonPhone] &&
      _.trim(values[Fields.StaffPersonPhone]).length < 14
    ) {
      errors[Fields.StaffPersonPhone] = 'Please enter a valid number.';
    }
  }

  return errors;
};

const mapStateToProps = state => {
  return {
    formValues: getFormValues(VERIFICATION_RESULTS_LETTERS_FORM_NAME)(state),
    resultsCounts: state.ResultsLettersState.report.resultsCounts,
  };
};

const VerificationResultsLettersForm = reduxForm({
  form: VERIFICATION_RESULTS_LETTERS_FORM_NAME,
  enableReinitialize: true,
  validate,
  destroyOnUnmount: false,
})(withRouter(connect(mapStateToProps, {})(ResultsLettersFormContainer)));

export { VerificationResultsLettersForm };



// WEBPACK FOOTER //
// ./src/pages/resultsletters/components/VerificationResultsLettersForm.js